import React, { CSSProperties } from 'react';
import { TextFieldComponent } from '@vivli/shared/components';
import { ButtonView } from '@vivli/shared/views';
import { Color, Size } from '@vivli/shared/theme';

const containerStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: Color.VIVLI_DARK_BLUE,
    color: Color.WHITE,
    minWidth: 300,
    borderRadius: 15
};

const headerStyle: CSSProperties = {
    padding: Size.PADDING * 2,
    borderBottom: '1px solid white',
    fontSize: Size.FontSize.Larger,
    alignContent: 'center'
};

const bodyContainerStyle: CSSProperties = {
    padding: Size.PADDING * 2,
    fontSize: Size.FontSize.Medium
};

const instructionStyle: CSSProperties = {
    fontSize: Size.FontSize.Large,
    textAlign: 'left',
    fontWeight: Size.FontWeight.SemiBold
};

const contentStyle: CSSProperties = {
    display: 'grid',
    gap: '20px',
    padding: Size.PADDING,
    color: 'rgb(96, 104, 111)',
    backgroundColor: 'rgb(246, 247, 251)'
};

const fieldContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    justifyItems: 'left'
};

const linkStyle: CSSProperties = {
    fontSize: Size.FontSize.Large,
    color: Color.VIVLI_LIGHT_BLUE,
    textDecoration: 'underline',
    cursor: 'pointer'
};

const buttonContainerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    justifyItems: 'center',
    paddingTop: '20px'
};

const errorStyle: CSSProperties = {
    color: Color.ERROR_RED,
    fontSize: Size.FontSize.Large,
    paddingTop: '4px'
};

export interface AddRequestedStudyDuringDraftViewProps {
    studyIdValue: string;
    onStudyIdChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    studyIdError?: string;
    studyIdLabel?: string;
    onSubmitClick: () => void;
    isSubmitDisabled?: boolean;
    isLoading?: boolean;
    enquiriesUrl: string;
    onCancelClick?: () => void;
}

export const AddRequestedStudyDuringDraftView = ({
    studyIdValue,
    onStudyIdChange,
    studyIdError,
    studyIdLabel,
    onSubmitClick,
    isSubmitDisabled,
    isLoading,
    enquiriesUrl,
    onCancelClick
}: AddRequestedStudyDuringDraftViewProps) => {
    const onEnquiryClick = () => window.open(enquiriesUrl, '_blank');

    return (
        <div>
            <div style={containerStyle} className={'add-requested-study-during-draft-view'}>
                <div style={headerStyle}>Add a Study to this Data Request</div>
                <div style={bodyContainerStyle}>
                    <div style={contentStyle}>
                        <div style={instructionStyle}>
                            <div>To add a study enter its NCT ID or Sponsor Protocol ID.</div>
                            <div className={'study-id-instruction-and-link'}>
                                If you don’t know the ID, search{' '}
                                <span style={linkStyle} onClick={() => window.open(`${window.location.origin}/?search`, '_blank')}>
                                    here
                                </span>{' '}
                                using additional parameters.
                            </div>
                            If you have questions about studies or their availability on the Vivli platform, click Start an Enquiry.
                        </div>
                        <div style={fieldContainerStyle}>
                            <TextFieldComponent
                                label={studyIdLabel}
                                value={studyIdValue}
                                onChange={onStudyIdChange}
                                error={studyIdError}
                                focusOnLoad={true}
                            />
                            {studyIdError && <div style={errorStyle}>{studyIdError}</div>}
                        </div>
                        <div style={buttonContainerStyle}>
                            <ButtonView
                                onClick={onSubmitClick}
                                disabled={isSubmitDisabled}
                                isLoading={isLoading}
                                dataId="add-this-study-button"
                            >
                                Add this Study
                            </ButtonView>
                            <ButtonView onClick={onEnquiryClick} disabled={false} isLoading={isLoading} dataId="start-an-enquiry-button">
                                Start an Enquiry
                            </ButtonView>
                            <ButtonView
                                style={{ backgroundColor: Color.VIVLI_RED }}
                                onClick={onCancelClick}
                                dataId="cancel-add-study-button"
                            >
                                Cancel
                            </ButtonView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
